export { default } from './HorizontalTimeline';
